module.exports = __webpack_public_path__ + "img/Logo Default.e3847771.svg";